export interface PreviousDocumentsAddFormModel {
  idCasePreviousDocumentMap?: number;
  webId: string;
  finalActDocumentName: string;
  classification: string;
  finalActFileNumber: string;
  solutionType: string;
  finalDocumentAdmissionDate?: Date;
  executionDate?: Date;
  effectivenessDate?: Date;
  executionAndEffectivenessDateMandatory: boolean;
  dataFetched: boolean;
  authority: string;
  administrativeUnit: string;
  authorityOfficeOldName: string;
}

export const previousDocumentsAddFormInitial = {
  webId: '',
  finalActDocumentName: '',
  classification: '',
  finalActFileNumber: '',
  solutionType: '',
  finalDocumentAdmissionDate: null,
  executionDate: null,
  effectivenessDate: null,
  executionAndEffectivenessDateMandatory: false,
  dataFetched: false,
} as PreviousDocumentsAddFormModel;

export interface PreviousDocumentsPage {
  totalElements: number;
  content: PreviousDocumentsAddFormModel[];
}
